export interface MyDrawTonightResponse {
  configured: boolean;
  playerNumbers: number[] | null;
  combinationId?: number;
  combinationName?: string;
  tirageNumbers?: number[] | null;
  tirageDate?: string;
  isToday?: boolean;
  matched?: number[];
  matchCount?: number;
  history?: Array<{
    date: string;
    matchCount: number;
    matched: number[];
  }>;
  myDrawNotification?: string;
  /** « Non merci » déjà répondu au choix du mail de résultat : la question n'est plus proposée. */
  mailResultatRefuse?: boolean;
  error?: string;
}

export async function getMyDrawTonight(): Promise<MyDrawTonightResponse> {
  const res = await fetch("/_api/auth/my-draw-tonight");
  if (!res.ok) throw new Error("Erreur lors du chargement");
  return res.json();
}
